import { postReq } from '../infra/http';
import { getReq, createUrl } from "@/infra/http";
import { activityFromJson, ActivityInfo, ActivityInfoPaginationFilterRequest, ActivityTypeList, UpsertActivityInfo } from '@/models/activity-info.model';
import { PaginationFilterRequest, PagedResponseModel, BaseResponseModel, PaginatedSelectModel } from "@/models/core.model";

export const getPagedActivityInfos = async (input: ActivityInfoPaginationFilterRequest): Promise<PagedResponseModel<ActivityInfo>> => {
  return await getReq(createUrl("a/ActivityInfo/PagedData"),
    { params: input }
  ).then((res: any) => ({
    ...res.data,
    result: res.data.result.map(itm => activityFromJson(itm))
  }));
};

export const getActivityInfosLookup = async (input?: string, page?: number): Promise<PaginatedSelectModel> => {
  const model: PaginationFilterRequest = {
    pageNumber: page ?? 1,
    pageSize: 100,
    keyword: input,
    isAscending: false
  };
  return await getPagedActivityInfos(model).then(data => 
  ({ 
    data: data.result.map(a => ({ 
      value: a.id, 
      label: `${a.id}, Type: ${ActivityTypeList.findLast(t=> t.value == a.activityType)?.label ?? '-'}, User: ${a.user.firstName} ${a.user.lastName}, Start: ${a.startTime.toLocaleString()},  City: ${a.city?.name ?? '-'}, Country: ${a.country?.name ?? '-'}` 
    })),
    isLastPage: data.pageNumber >= data.totalPages,
  }));
};

export const getActivityInfo = async (id: number): Promise<BaseResponseModel<ActivityInfo>> => {
  return await getReq(createUrl(`a/ActivityInfo/GetById/${id}`),
  ).then((res: any) => ({
    ...res.data,
    result: activityFromJson(res.data.result)
  }));
};

export const upsertActivityInfo = async (input: UpsertActivityInfo): Promise<BaseResponseModel<ActivityInfo>> => {
  return await postReq(createUrl("a/ActivityInfo/Upsert"),
    input
  ).then((res: any) => ({
    ...res.data,
    result: activityFromJson(res.data.result)
  }));
};

export const checkCountryActivitiesEmptyCity = async (countryId: number): Promise<BaseResponseModel<number>> => {
  return await postReq(createUrl("a/ActivityInfo/CheckEmptyCities"),
  { countryId },
  ).then((res: any) => res.data);
};
export const checkActivitiesEmptyCountry = async (): Promise<BaseResponseModel<number>> => {
  return await postReq(createUrl("a/ActivityInfo/CheckEmptyCountries"))
    .then((res: any) => res.data);
};

export const ExchangeLatLng = async (id: number): Promise<BaseResponseModel<null>> => {
  return await postReq(createUrl("a/ActivityInfo/ExchangeLatLng/" + id)
  ).then((res: any) => res.data);
};
